import { TRIAL_FEATURES } from '@/constants/trial';
import CheckIcon from '@/assets/icons/main-check.svg';
import InfoIcon from '@/assets/icons/information-circle.svg';
import { cn } from '@/lib/utils';
import { FC } from 'react';

interface TrialFeaturesSectionProps {
    containerClassName?: string
    textClassName?: string
    featuresContainerClassName?: string
}

export const TrialFeaturesSection: FC<TrialFeaturesSectionProps> = ({ containerClassName, textClassName, featuresContainerClassName }) => {
    return (
        <div className={cn("mt-10", containerClassName)}>
            <p className={cn('text-gray-500 text-sm leading-relaxed tracking-normal text-center', textClassName)}>
                <span className='block'>
                    Search and unlock companies, stakeholders and contacts to find your ideal buyers and ICP.
                </span>
                <span className='block'><strong className='font-semibold'>All advanced features are free</strong> to try during this period:</span>
            </p>
            <div className={cn('mt-8 w-fit mx-auto', featuresContainerClassName)}>
                <ul className="grid grid-cols-[auto_auto] gap-x-6 gap-y-3">
                    {TRIAL_FEATURES.map((item, index) => (
                        <li key={index} className="whitespace-nowrap">
                            <div className='flex items-center gap-2'>
                                <CheckIcon className='w-4 h-4 shrink-0' />
                                <div className='flex items-center gap-0.5'>
                                    <p className={cn('text-sm leading-relaxed tracking-normal', 'isNew' in item && item.isNew ? 'text-black' : 'text-gray-500')}>{item.label}</p>
                                    <InfoIcon className='w-4 h-4' />
                                    {'isNew' in item && item.isNew && (
                                        <span className='ml-2 rounded-full bg-[#5049E5] px-2 py-1 text-xs font-semibold leading-none tracking-normal text-white'>
                                            NEW!
                                        </span>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
                <p className='mt-6 text-gray-500 text-sm leading-none tracking-normal text-left'>And more...</p>
            </div>
        </div>
    );
}
